import React, { useState } from "react";

import { Box, useTheme } from "@mui/material";
import { Clipboard } from "react-feather";

import { DEFAULT_CLIPBOARD_SB_DURATION } from "../../constants/index";

interface CodeBoxProps {
  codeBlob: string;
}

const CodeBox: React.FC<CodeBoxProps> = ({ codeBlob }: CodeBoxProps) => {
  const theme = useTheme();
  const [buttonText, setButtonText] = useState("Copy");

  return (
    <Box
      component="span"
      sx={{
        display: "block",
        p: 1,
        m: 1,
        bgcolor: (theme) =>
          theme.palette.mode === "dark" ? "#101010" : "#fff",
        color: (theme) =>
          theme.palette.mode === "dark" ? "grey.300" : "grey.800",
        border: "1px solid",
        borderColor: (theme) =>
          theme.palette.mode === "dark" ? "grey.800" : "grey.300",
        borderRadius: 2,
        fontSize: "0.7rem",
        fontFamily: "monospace",
        fontWeight: "700",
        position: "relative",
        whiteSpace: "scroll", // Prevents text from wrapping
        overflow: "auto", // Hides overflowing content
        textOverflow: "ellipsis", // Adds "..." if text is too long
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 4,
          right: 4,
          cursor: "pointer",
        }}
      >
        <div
          onClick={() => {
            navigator.clipboard.writeText(codeBlob);
            setButtonText("Copied");
            setTimeout(() => {
              setButtonText("Copy");
            }, DEFAULT_CLIPBOARD_SB_DURATION);
          }}
          data-testid="code-box-copy"
        >
          <Clipboard
            color={theme.palette.text.primary}
            size={"1rem"}
            className="position-icon"
          />
          {buttonText}
        </div>
      </Box>
      <pre>{codeBlob}</pre>
    </Box>
  );
};

export default CodeBox;
